
export class Persona {
    constructor(
        public idPersona: number,
        public nombre: String,
        public identidad: string,
        public numeroColegiacion: string,
        public departamento: string,
        public municipio: string,
        public status: string,
        public grado: any,
        public monto: number,
        public voto: boolean,
        public mesa: number,
        public estado: boolean,
        public seleccionado: boolean,
       public idVotacion:number,
        public keyImg?: string
    ) { }
}


